import buildHeaders from './fetchHeaders';
import {API_BASE} from './reports';

/**
 * Upload a .docx file to the backend for parsing.
 * Returns { title, overallClassification, content (ProseMirror JSON doc node), authors,
 *           suggestedTopic, suggestedQuery, references, ...metadata }.
 *
 * @param {File} file - The .docx File object to upload
 * @returns {Promise<object>}
 */
export async function parseDocx(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE}/reports/parse-docx`, {
        method: 'POST',
        headers: buildHeaders({}),
        body: formData,
    });

    if (!response.ok) {
        let message = 'Failed to parse document';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    return await response.json();
}
